import { render, staticRenderFns } from "./SubjoinComponents.vue?vue&type=template&id=0328706e&scoped=true"
import script from "./SubjoinComponents.vue?vue&type=script&lang=js"
export * from "./SubjoinComponents.vue?vue&type=script&lang=js"
import style0 from "./SubjoinComponents.vue?vue&type=style&index=0&id=0328706e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0328706e",
  null
  
)

export default component.exports